const fillAddressData = (commit, address, isOffline) => {
  commit("setCep", address.postcode)
  commit("setAddress", address.address)
  commit("setNumber", address.number)
  commit("setNeighborhood", address.neighborhood)
  commit("setState", address.state)
  commit("setCity", address.city)
  commit("setComplements", isOffline ? address.complements : address.complement)
  commit(
    "setAddressNote",
    isOffline ? address.address_note : address.observation
  )
  commit("setNoNumber", !Boolean(address.number))
  commit(
    "setNoComplement",
    !(isOffline ? address.complements.length : address.complement.length)
  )
}

export default {
  fillOfflineAddress: ({ commit }, address) => {
    fillAddressData(commit, address, true)
  },
  fillAddress: ({ commit }, address) => {
    fillAddressData(commit, address, false)
  }
}
